import { render } from "./AudioPlayer.vue?vue&type=template&id=5c1ef8a2"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=5c1ef8a2&lang=css"
script.render = render

export default script